<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>
            <h3>{{ pageTitle }}</h3>
            <b-table
                responsive
                small
                :items="filteredItems"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="['search']"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="client_id"
                @filtered="onFiltered"
            >
                <template #cell(id)="data">
                    <div class="dropdown">
                        <button
                            id="dropdownMenuButton"
                            class="btn p-0 dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i class="far fa-bars"></i>
                        </button>
                        <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                        >
                            <b-link
                                v-if="showByCompany"
                                class="dropdown-item"
                                @click="
                                    byCompany(data.item.id, data.item.title)
                                "
                            >
                                <i class="fas fa-caret-right fa-fw"></i>
                                {{ data.item.title }} par cabinet
                            </b-link>
                            <b-link
                                v-if="showByActivity"
                                class="dropdown-item"
                                @click="
                                    byActivity(data.item.id, data.item.title)
                                "
                            >
                                <i class="fas fa-caret-right fa-fw"></i>
                                {{ data.item.title }} par activité
                            </b-link>
                            <b-link
                                v-if="showByClient"
                                class="dropdown-item"
                                @click="byClient(data.item.id, data.item.title)"
                            >
                                <i class="fas fa-caret-right fa-fw"></i>
                                {{ data.item.title }} par client
                            </b-link>
                        </div>
                    </div>
                </template>
                <template #cell(jan)="data">
                    <span class="number-font">{{ formatNumber(data.item.jan) }}</span>
                </template>
                <template #cell(feb)="data">
                    <span class="number-font">{{ formatNumber(data.item.feb) }}</span>
                </template>
                <template #cell(mar)="data">
                    <span class="number-font">{{ formatNumber(data.item.mar) }}</span>
                </template>
                <template #cell(apr)="data">
                    <span class="number-font">{{ formatNumber(data.item.apr) }}</span>
                </template>
                <template #cell(may)="data">
                    <span class="number-font">{{ formatNumber(data.item.may) }}</span>
                </template>
                <template #cell(jun)="data">
                    <span class="number-font">{{ formatNumber(data.item.jun) }}</span>
                </template>
                <template #cell(jul)="data">
                    <span class="number-font">{{ formatNumber(data.item.jul) }}</span>
                </template>
                <template #cell(aug)="data">
                    <span class="number-font">{{ formatNumber(data.item.aug) }}</span>
                </template>
                <template #cell(sep)="data">
                    <span class="number-font">{{ formatNumber(data.item.sep) }}</span>
                </template>
                <template #cell(oct)="data">
                    <span class="number-font">{{ formatNumber(data.item.oct) }}</span>
                </template>
                <template #cell(nov)="data">
                    <span class="number-font">{{ formatNumber(data.item.nov) }}</span>
                </template>
                <template #cell(dec)="data">
                    <span class="number-font">{{ formatNumber(data.item.dec) }}</span>
                </template>
                <template #cell(year)="data">
                    <span class="number-font">{{ formatNumber(data.item.year) }}</span>
                </template>
                <!-- FOOT -->
                <template #custom-foot="data">
                    <b-tr class="bg-light">
                        <b-th></b-th>
                        <b-th>TOTAL</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.jan)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.feb)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.mar)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.apr)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.may)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.jun)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.jul)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.aug)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.sep)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.oct)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.nov)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.dec)
                        }}</b-th>
                        <b-th class="text-right number-font">{{
                            formatNumber(total.year)
                        }}</b-th>
                    </b-tr>
                </template>
            </b-table>
            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
        <hr />
        <div v-show="!loading">
            <vue-chart-bar
                :chartdata="chartData"
                :options="chartOptions"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from '../../../common/components/loading'
import vueChartBar from '../../../common/components/vueChartLine'
import TableHandler from '../../../common/mixins/TableHandler'
import DashboardHandler from '../../mixins/DashboardHandler'

export default {
    name: 'FeesInteractive',

    components: {
        loading,
        vueChartBar,
    },

    mixins: [TableHandler, DashboardHandler],

    data() {
        return {
            fields: [
                { key: 'id', label: '', class: 'td-icon', sortable: false },
                { key: 'title', label: '', sortable: true },
                {
                    key: 'jan',
                    label: 'jan',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'feb',
                    label: 'fév',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'mar',
                    label: 'mar',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'apr',
                    label: 'avr',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'may',
                    label: 'mai',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'jun',
                    label: 'jun',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'jul',
                    label: 'jul',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'aug',
                    label: 'aoû',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'sep',
                    label: 'sep',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'oct',
                    label: 'oct',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'nov',
                    label: 'nov',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'dec',
                    label: 'déc',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'year',
                    label: 'TOTAL',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
            ],
            total: {},
            dataUrl: '',
            showByClient: true,
            showByActivity: true,
            showByCompany: true,
            filterType: 'all',
            filterId: '',
            pageTitle: 'Global',
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                hover: {
                    animationDuration: 0,
                },
                responsiveAnimationDuration: 0,
                legend: {
                    position: 'bottom',
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },

            chartData: {
                labels: [
                    'jan',
                    'fév',
                    'mar',
                    'avr',
                    'mai',
                    'jun',
                    'jul',
                    'aou',
                    'sep',
                    'oct',
                    'nov',
                    'déc',
                ],
                datasets: [],
            },
            sortBy: 'title',
            sortDesc: false,
        }
    },

    async created() {
        this.dataUrl = 'dashboard/fees/global/'
        this.$store.commit('browsing/SET_PAGE_NAME', 'fees-interactive')
        this.$store.commit('browsing/INIT_YEAR')
        await this.getData()
    },

    methods: {
        async byCompany(id, title) {
            this.showByClient = true
            this.showByActivity = true
            this.showByCompany = false
            this.dataUrl = 'dashboard/fees/by-company/'
            this.filterId = id
            await this.getData()
            this.pageTitle = title
            this.filterType = 'company'
        },

        async byActivity(id, title) {
            this.showByClient = true
            this.showByActivity = false
            this.showByCompany = true
            this.dataUrl = 'dashboard/fees/by-activity/'
            this.filterId = id
            await this.getData()
            this.pageTitle = title
            this.filterType = 'activity'
        },

        async byClient(id, title) {
            this.showByClient = false
            this.showByActivity = true
            this.showByCompany = false
            this.filterId = id
            this.dataUrl = 'dashboard/fees/by-client/'
            await this.getData()
            this.pageTitle = title
            this.filterType = 'client'
        },

        async getData() {
            this.loading = true
            try {
                const response = await axios.get(
                    `${this.dataUrl + this.year}/${this.filterType}/${
                        this.filterId
                    }`
                )
                this.items = response.data.data
                this.calculateTotal()
                this.updateTotalRows()
                this.setChartData()
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        initTotal() {
            this.total.jan = 0
            this.total.feb = 0
            this.total.mar = 0
            this.total.apr = 0
            this.total.may = 0
            this.total.jun = 0
            this.total.jul = 0
            this.total.aug = 0
            this.total.sep = 0
            this.total.oct = 0
            this.total.nov = 0
            this.total.dec = 0
            this.total.year = 0
        },

        calculateTotal() {
            this.initTotal()

            this.items.forEach((item) => (this.total.jan += item.jan))
            this.items.forEach((item) => (this.total.feb += item.feb))
            this.items.forEach((item) => (this.total.mar += item.mar))
            this.items.forEach((item) => (this.total.apr += item.apr))
            this.items.forEach((item) => (this.total.may += item.may))
            this.items.forEach((item) => (this.total.jun += item.jun))
            this.items.forEach((item) => (this.total.jul += item.jul))
            this.items.forEach((item) => (this.total.aug += item.aug))
            this.items.forEach((item) => (this.total.sep += item.sep))
            this.items.forEach((item) => (this.total.oct += item.oct))
            this.items.forEach((item) => (this.total.nov += item.nov))
            this.items.forEach((item) => (this.total.dec += item.dec))
            this.items.forEach((item) => (this.total.year += item.year))
        },

        setChartData() {
            this.chartData.datasets = [
                {
                    label: 'CA (en €)',
                    backgroundColor: 'rgba(46, 92, 158, 0.4)',
                    borderColor: 'rgba(46, 92, 158, 1)',
                    borderWidth: 1,
                    data: [
                        Math.round(this.total.jan),
                        Math.round(this.total.feb),
                        Math.round(this.total.mar),
                        Math.round(this.total.apr),
                        Math.round(this.total.may),
                        Math.round(this.total.jun),
                        Math.round(this.total.jul),
                        Math.round(this.total.aug),
                        Math.round(this.total.sep),
                        Math.round(this.total.oct),
                        Math.round(this.total.nov),
                        Math.round(this.total.dec),
                    ],
                },
            ]
        },

        formatNumber(number) {
            if (number === 0) {
                return '-'
            }
            if (number === null) {
                return '-'
            }
            return Math.floor(number).toLocaleString()
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },
}
</script>

<style scoped></style>
